// extracted by mini-css-extract-plugin
export default {"overlay":"loader_overlay__CZ3qN","loader":"loader_loader__NbhhB","l1":"loader_l1__J0S4Z"};